var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Navbar',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.getPaste.id),expression:"$store.getters.getPaste.id"}],attrs:{"title":_vm.$store.getters.getPaste.title,"date":_vm.formatDate(_vm.$store.getters.getPaste.date),"lang":_vm.$store.getters.getLang,"pasteId":_vm.$store.getters.getPaste.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }